<template>
  <div>
    <div class="page-title">
      <div class="container">
        <ul class="nav">
          <li class="nav-item border-left-0">
            <a class="nav-link" @click="goHome()">
              <img src="~../assets/image/icon/home.png" height="40" />
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link">考試作業</a>
          </li>
        </ul>
      </div>
    </div>

    <div class="container mt-3 pt-5" :class="{ 'bg-white': isEmpty }">
      <template v-if="isEmpty">
        <empty-page title="沒有指派任何考試作業" description="目前沒有老師指派任何考試作業給您。" />
        <div class="row mt-5 d-flex">
          <button class="btn btn-success btn-block mt-5 mb-5 w-50 mx-auto" @click.stop.prevent="$router.push('/')">我知道了</button>
        </div>
      </template>

      <div class="row" v-else>
        <div class="col-sm-6 offset-sm-3">
          <ul class="list-group">
            <li class="list-group-item d-flex justify-content-between p-0 mb-3 rounded"
              v-for="exam in exams.list" :key="exam.id">
              <div class="text-left p-3 mr-auto">
                考試內容：<span style="font-weight: bold;">{{ exam.name }}</span><br>
                指派班級：{{ exam.groupName }}<br>
                指派老師：{{ exam.teacherName }}<br>
                建立日期：{{ exam.createTime }}
              </div>
              <div class="d-flex align-items-center pr-3">
                <img src="~../assets/image/icon/check_on.png" v-if="exam.isDone">
                <img src="~../assets/image/icon/check_off.png" v-else>
              </div>
              <div class="d-flex align-items-center rounded list-group-item-playbtn" style="background-color: #5aa5f8;">
                <span class="w-100 text-center"
                  @click="$router.push('/exams/start/' + exam.id)">
                  <img src="~../assets/image/icon/video_play.png">
                </span>
              </div>
            </li>
          </ul>

          <pagination class="mt-5" :current="exams.pageIndex" :total="exams.pageCount" v-on:page="updatePage" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Pagination from '../components/Pagination'
import EmptyPage from './Teacher/EmptyPage'

export default {

  name: 'Works',

  components: {
    Pagination,
    EmptyPage
  },

  data () {
    return {

    }
  },

  computed: {
    ...mapGetters([
      'exams'
    ]),

    isEmpty () {
      return this.exams.list.length === 0
    }
  },

  mounted () {
    this.getExamList()
  },

  methods: {
    ...mapActions([
      'getExamList'
    ]),

    updatePage (page) {
      this.getExamList({ pageIndex: page })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// Exams.vue?1e00c20c